import { render, staticRenderFns } from "./Textbox.vue?vue&type=template&id=a082fed2&scoped=true&"
import script from "./Textbox.vue?vue&type=script&lang=js&"
export * from "./Textbox.vue?vue&type=script&lang=js&"
import style0 from "./Textbox.vue?vue&type=style&index=0&id=a082fed2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a082fed2",
  null
  
)

export default component.exports